import { createMetricUpdatesChangeExtension } from '@spotify/plugin-confidence-metrics-react';

// Suppresses the /measurement_config entry — its sub-fields (aggregation_window,
// exposure_offset) are already shown via dedicated duration change extensions.
export const METRIC_MEASUREMENT_CONFIG_SUPPRESS_EXTENSION =
  createMetricUpdatesChangeExtension({
    id: 'metric-measurement-config-suppress',
    suppress: true,
    predicate: ({ change }) => change.fieldPath === '/measurement_config',
    render: () => null,
  });
